export class GeneralDates {}
